import * as SelectPrimitive from '@radix-ui/react-select';
import type * as React from 'react';
import { cn } from '@/shared/lib/utils';

/**
 * SelectItem - セレクトアイテム
 */
type SelectItemProps = React.ComponentPropsWithRef<typeof SelectPrimitive.Item>;

export const SelectItem = ({ className, children, ref, ...props }: SelectItemProps) => {
  return (
    <SelectPrimitive.Item
      ref={ref}
      className={cn(
        'relative flex w-full cursor-default select-none items-center',
        'rounded-sm py-1.5 pr-2 pl-2 text-sm',
        'outline-none',
        'focus:bg-neutral-100',
        'data-[state=checked]:bg-brand-100 data-[state=checked]:font-bold',
        'data-disabled:pointer-events-none data-disabled:opacity-50',
        'cursor-pointer',

        className,
      )}
      {...props}
    >
      <SelectPrimitive.ItemText>{children}</SelectPrimitive.ItemText>
    </SelectPrimitive.Item>
  );
};
SelectItem.displayName = SelectPrimitive.Item.displayName;
